<template>
	<el-header>
		<div class="bar">
			<div class="logo">
				<img alt="Vue logo" src="@/assets/logo.png" />
				鼎成教育
			</div>
			<div class="menus-2">
				<el-tabs
					:model-value="menuActive"
					@update:model-value="updateMenuActive"
					@tab-click="handleClickMenus"
				>
					<el-tab-pane
						v-for="(item, index) in topNaves"
						:key="index"
						:label="item.meta.title"
						:name="JSON.stringify(item)"
					></el-tab-pane>
				</el-tabs>
			</div>

			<div class="profile">
				<!-- 数据中台入口 -->
				<div class="data-center" v-if="centerDataShow">
					<el-button class="data-center-btn" size="small" @click="goDataCenter">
						<img class="data-center-icon" src="@/assets/images/centerData.png" alt="数据中台" />
						数据中台
					</el-button>
				</div>
				<div class="tag-info" v-if="msgNum > 0 || otherNum > 0">
					您有{{ msgNum + otherNum > 99 ? '99+' : msgNum + otherNum }}条通知待处理~
				</div>

				<!-- 消息通知组件 -->
				<MessageDropdown
					:msg-num="msgNum"
					:other-num="otherNum"
					:msg-loading="msgLoading"
					:active-name-msg="activeNameMsg"
					:msg-list="msgList"
					:other-list="otherList"
					:show-scroll="show_scroll"
					@show-scroll="showScorll"
					@message-readed="messageReaded"
					@message-readed-other="messageReadedOther"
					@load="load"
					@load-other="loadOther"
					@read-all="readAllFun"
					@update:active-name-msg="updateActiveNameMsg"
				/>

				<!-- 用户下拉菜单组件 -->
				<UserDropdown
					:userInfo="userInfoAll"
					@go-user-info="goUserInfo"
					@go-operating-manual="goOperatingManual"
					@clear-cache="clearCache"
					@logout="onLogout"
				/>
			</div>
		</div>
	</el-header>
</template>

<script setup>
import { ref } from 'vue'
import MessageDropdown from './MessageDropdown.vue'
import UserDropdown from './UserDropdown.vue'

const centerDataShow = ref(JSON.parse(localStorage.getItem('DC-info')).zt_is_show)

// Props
const props = defineProps({
	topNaves: {
		type: Array,
		default: () => []
	},
	menuActive: {
		type: String,
		default: ''
	},
	msgNum: {
		type: Number,
		default: 0
	},
	otherNum: {
		type: Number,
		default: 0
	},
	msgLoading: {
		type: Boolean,
		default: false
	},
	activeNameMsg: {
		type: String,
		default: '公告'
	},
	msgList: {
		type: Array,
		default: () => []
	},
	otherList: {
		type: Array,
		default: () => []
	},
	show_scroll: {
		type: Boolean,
		default: false
	},
	userInfoAll: {
		type: Object,
		default: () => ({})
	}
})

// Emits
const emit = defineEmits([
	'update:menuActive',
	'update:activeNameMsg',
	'handle-click-menus',
	'show-scroll',
	'message-readed',
	'message-readed-other',
	'load',
	'load-other',
	'read-all',
	'go-user-info',
	'go-operating-manual',
	'clear-cache',
	'logout',
	'go-data-center'
])

const goDataCenter = () => {
	emit('go-data-center')
}
// Methods
const updateMenuActive = (value) => {
	emit('update:menuActive', value)
}

const handleClickMenus = (tab, event) => {
	emit('handle-click-menus', tab, event)
}

const showScorll = () => {
	emit('show-scroll')
}

const messageReaded = (item, index) => {
	emit('message-readed', item, index)
}

const messageReadedOther = (item, index) => {
	emit('message-readed-other', item, index)
}

const load = () => {
	emit('load')
}

const loadOther = () => {
	emit('load-other')
}

const readAllFun = () => {
	emit('read-all')
}

const goUserInfo = () => {
	emit('go-user-info')
}

const goOperatingManual = () => {
	emit('go-operating-manual')
}

const clearCache = () => {
	emit('clear-cache')
}

const onLogout = () => {
	emit('logout')
}

const updateActiveNameMsg = (value) => {
	emit('update:activeNameMsg', value)
}
</script>

<style scoped lang="scss">
.menus-2 {
	width: 62%;
	// margin-top: 7px;
}

:deep(.el-tabs__item) {
	padding: 10px;
}

.tag-info {
	color: cornflowerblue;
	font-size: 12px;
	margin-right: 10px;
	animation: 2s opacity 0s infinite;
	margin-left: 30px;
}

@keyframes opacity {
	0% {
		opacity: 0;
	}

	50% {
		opacity: 0.8;
	}

	100% {
		opacity: 0;
	}
}

.bar {
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 100%;
}

.logo {
	display: flex;
	align-items: center;
	font-size: 18px;
	font-weight: bold;

	img {
		width: 36px;
		height: 36px;
		margin-right: 8px;
	}
}

.profile {
	display: flex;
	align-items: center;
}

:deep(.el-tabs__header) {
	margin: 0 !important;
}

/* 数据中台按钮：胶囊描边样式（浅品牌蓝 #7DA9FF） */
.data-center {
	margin-right: 15px;
}

.data-center-btn {
	color: #fff;
	font-weight: 600;
	height: 32px;
	padding: 0 18px;
	border: 1px solid #ffffff;
	border-radius: 999px;
	background: #7da9ff;
	box-shadow: 0 2px 8px rgba(125, 169, 255, 0.4);
}

.data-center-btn:hover,
.data-center-btn:focus {
	color: #fff;
	background: #93b9ff;
	border-color: #ffffff;
	box-shadow: 0 4px 12px rgba(125, 169, 255, 0.5);
}

.data-center-icon {
	width: 14px;
	height: 14px;
	margin-right: 4px;
	display: inline-block;
	vertical-align: middle;
}
</style>
